import PolyLoader from "./PolyLoader";

export default PolyLoader;
